import React, { type FunctionComponent } from 'react'
import { CloseIcon } from '../../../../../icons'
import { Button } from '@tomra/design-system-react/button'

type Props = {
  label: string
  filterKey: keyof CharityFilterType
  filter: CharityFilterType
  setFilter: React.Dispatch<React.SetStateAction<CharityFilterType>>
}

export const CharityDateFilter: FunctionComponent<Props> = ({ label, filterKey, filter, setFilter }) => {
  const inputRef = React.useRef<HTMLInputElement>(null)

  function clear() {
    setFilter(prev => ({ ...prev, [filterKey]: undefined }))

    if (inputRef.current) {
      inputRef.current.value = ''
    }
  }

  function updateFilter(value: string) {
    setFilter(prev => ({ ...prev, [filterKey]: value }))
  }

  return (
    <>
      <div className="flex space-x-sm items-end">
        <div className="flex-1">
          <label htmlFor={label} className="label">
            {label}
          </label>
          <input
            id={label}
            ref={inputRef}
            type="date"
            value={filter[filterKey as keyof CharityFilterType] || undefined}
            onChange={({ target }) => updateFilter(target.value)}
            className="border border-gray-300 rounded px-3 py-2 bg-white w-full focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent"
          />
        </div>
        <Button size="icon" aria-label="Clear date" onClick={clear}>
          <CloseIcon width="1rem" height="1rem" />
        </Button>
      </div>
    </>
  )
}
